export const AltProductImagePath: string = "https://nf.aaoinfo.org/eweb/images/DEMO1/notavailable.jpg";
export const IVA = 0.16;

export class CustomerTypeCodes
{
  public static readonly Alpha = 'ct0001';
  public static readonly Digital = 'ct0002';
  public static readonly PAEI = 'ct0003';
  public static readonly DigitalPro = 'ct0004';
  public static readonly PRIME = 'ct0005';
}

export const CARDMONTHS = [
  { name: 'ENERO', value: "01" },
  { name: 'FEBRERO', value: "02" },
  { name: 'MARZO', value: "03" },
  { name: 'ABRIL', value: "04" },
  { name: 'MAYO', value: "05" },
  { name: 'JUNIO', value: "06" },
  { name: 'JULIO', value: "07" },
  { name: 'AGOSTO', value: "08" },
  { name: 'SEPTIEMBRE', value: "09" },
  { name: 'OCTUBRE', value: "10" },
  { name: 'NOVIEMBRE', value: "11" },
  { name: 'DICIEMBRE', value: "12" }
];

export const MONTHS = [
  { name: 'MES', value: -1 },
  { name: 'ENERO', value: 0 },
  { name: 'FEBRERO', value: 1 },
  { name: 'MARZO', value: 2 },
  { name: 'ABRIL', value: 3 },
  { name: 'MAYO', value: 4 },
  { name: 'JUNIO', value: 5 },
  { name: 'JULIO', value: 6 },
  { name: 'AGOSTO', value: 7 },
  { name: 'SEPTIEMBRE', value: 8 },
  { name: 'OCTUBRE', value: 9 },
  { name: 'NOVIEMBRE', value: 10 },
  { name: 'DICIEMBRE', value: 11 }
];

export const STATES = [
  {name: "Aguascalientes", value: 1},
  {name: "Baja California", value: 2},
  {name: "Baja California Sur", value: 3},
  {name: "Campeche", value: 4},
  {name: "Chiapas", value: 5},
  {name: "Chihuahua", value: 6},
  {name: "Ciudad de México", value: 7},
  {name: "Coahuila", value: 8},
  {name: "Colima", value: 9},
  {name: "Durango", value: 10},
  {name: "Estado de México", value: 11},
  {name: "Guanajuato", value: 12},
  {name: "Guerrero", value: 13},
  {name: "Hidalgo", value: 14},
  {name: "Jalisco", value: 15},
  {name: "Michoacán", value: 16},
  {name: "Morelos", value: 17},
  {name: "Nayarit", value: 18},
  {name: "Nuevo León", value: 19},
  {name: "Oaxaca", value: 20},
  {name: "Puebla", value: 21},
  {name: "Querétaro", value: 22},
  {name: "Quintana Roo", value: 23},
  {name: "San Luis Potosí", value: 24},
  {name: "Sinaloa", value: 25},
  {name: "Sonora", value: 26},
  {name: "Tabasco", value: 27},
  {name: "Tamaulipas", value: 28},
  {name: "Tlaxcala", value: 29},
  {name: "Veracruz", value: 30},
  {name: "Yucatán", value: 31},
  {name: "Zacatecas", value: 32},
];

export const SITEMAPURLS = [
  {name: 'Inicio', url: 'ecommerce'},
  {name: 'Tienda', url: 'tienda'},
  {name: 'Mis Casos', url: 'mis-casos'},
];

export const CRUDCASESTEPS = [
  {name: 'Paciente', url: 'paciente'},
  {name: 'Registros dentales', url: 'registros-dentales/1'},
  {name: 'Prescripción', url: 'prescripcion/1'},
  {name: 'Confirmación del Caso', url: 'confirmacion-caso'},
  {name: 'Pago', url: 'pago'}
];

export const CRUDCASESTEPSEXTENDED = [
  {name: 'Paciente', url: 'paciente'}, // 1.0
  {name: 'Paciente Detalle', url: 'paciente/'}, // 1.1
  {name: 'Fotografías/Composite', url: 'registros-dentales/1'}, // 2.1
  {name: 'Radiografías/Archivos STL', url: 'registros-dentales/2'}, // 2.2
  {name: 'Paso 1', url: 'prescripcion/1'}, // 3.1
  {name: 'Paso 2', url: 'prescripcion/2'}, // 3.2
  {name: 'Paso 3', url: 'prescripcion/3'}, // 3.3
  {name: 'Paso 4', url: 'prescripcion/4'}, // 3.4
  {name: 'Paso 5', url: 'prescripcion/5'}, // 3.5
  {name: 'Paso 6', url: 'prescripcion/6'}, // 3.6
  {name: 'Paso 7', url: 'prescripcion/7'}, // 3.7
  {name: 'Paso 8', url: 'prescripcion/8'}, // 3.8
  {name: 'Paso 9', url: 'prescripcion/9'}, // 3.9
  {name: 'Confirmación del Caso', url: 'confirmacion-caso'}, // 4.0
  {name: 'Pago', url: 'pago'} // 5.0
];

export class SpecialCharacters
{
  public static accents = [
    { text: 'Á', value: '&Aacute;' },
    { text: 'É', value: '&Eacute;' },
    { text: 'Í', value: '&Iacute;' },
    { text: 'Ó', value: '&Oacute;' },
    { text: 'Ú', value: '&Uacute;' },
    { text: 'á', value: '&aacute;' },
    { text: 'é', value: '&eacute;' },
    { text: 'í', value: '&iacute;' },
    { text: 'ó', value: '&oacute;' },
    { text: 'ú', value: '&uacute;' },
    { text: 'Ñ', value: '&Ntilde;' },
    { text: 'ñ', value: '&ntilde;' }
  ];
}

export class CommonRegex
{
  public static readonly DoubleOnly = new RegExp(/^[0-9]{0,13}(\.[0-9]{0,2}){0,1}$/g);
  public static readonly IntegerOnly = new RegExp(/^[0-9]{0,9}$/g);
  public static readonly OpenPayCardNumber = new RegExp(/^[\d-]{0,19}$/g);
  public static readonly CVV2 = new RegExp(/^[0-9]{0,4}$/g);
  public static readonly OpenPayExpirationYear = new RegExp(/^[0-9]{0,2}$/g);
  public static readonly PhoneNumber = new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g);
}

export enum StorageItems
{
  AkkyRoutes = "akky-routes",
  DirectusURL = "akky-directus-url",
  CookiesAdd = "cookies-add",
  SelectedLang = "selectedLang",
  HubFormStorageKey = "hub-form-storage-key",
}

export enum AppEventNames
{
  OnSettingsDone = "on-settings-done-event",
  OnCheckUserLoggedIn = "on-check-user-logged-in",
  OnCheckOrderToManufacture = "on-check-order-to-manufacture",
  onUpdateProtocolForUseAligners = "on-update-protocol-for-use-aligners",
  onGeneratePrescriptionDocument = "on-generate-prescription-document",
  onCompleteCase = "on-complete-case",
  onChargeDoneServices = "on-charge-done-services",
  onChargeDoneProducts = "on-charge-done-products",
  onUpdatePrescriptionStepByNumber = "on-update-prescription-step-number",
  onPatientSelected = "on-patient-selected",
  onCompleteSetup = "on-complete-setup",
  onCompositeValidity = "on-composite-validity",
  onPhotographyValidity = "on-photography-validity",
  onSTLValidity = "on-stl-validity",
  onCaseStagesChange = "on-case-stages-change",
  onUseNewAligners = "on-use-newAligners",
  onSelectPurchasedProduct = "on-select-purchased-product",
  onUpdatePrescriptionFiles = "on-update-prescription-files",
  onPrescriptionDocumentCreated = "on-prescription-document-created",
  onDentalMonitoringSmartSTLCreated = "on-dental-monitoring-smart-stl-created",
  onNotAFirstStageCreated = "on-not-a-first-stage-created",
  onPrescriptionStepsSaved = "on-prescription-steps-saved",
  isNewPrescription = "is-new-prescription"
}

export const enum SEODefaults
{
  Title = "Aliwell",
}

export enum DefaultLanguage
{
  ES = "es",
  EN = "en"
}
